// import { GameData } from "../../gamestate/gameData";
import { createMovieClip } from "../../functions/Functions_General";
import { jackppotGameFadeIn } from "../jackpotGlobalFunctions";
// import { getParameterByName } from "../../../common/getParameters";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { Howl } from "howler";
import DeviceChecker from "../../functions/helper.ts/DeviceChecker";

export class JackpotIntroText {
  private parent: PIXI.Container;
  private activeGameData: CommonData;
  private fireworks: Array<PIXI.extras.AnimatedSprite>;
  private fireworksContainer: PIXI.Container;
  private jackpotText: PIXI.Sprite;
  private jackpotTextAnimation: PIXI.tween.Tween;
  private exitTween: PIXI.tween.Tween;
  private mask: PIXI.Graphics;
  // private blackBG:PIXI.Graphics;
  private blackBG: PIXI.Sprite;
  private jackpotInSound: Howl;
  private exitTimer: any;

  // private exitFunction:Function;

  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.activeGameData = activeGameData;
    this.exitTimer = null;

    this.jackpotText = new PIXI.Sprite(
      PIXI.Texture.fromFrame("jackpotIntro.png")
    );
    this.jackpotText.anchor.set(0.5);
    this.jackpotText.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );

    this.jackpotTextAnimation = PIXI.tweenManager.createTween(this.jackpotText);
    this.jackpotTextAnimation
      .from({ alpha: 1, scale: { x: 0.8, y: 0.8 } })
      .to({ alpha: 1, scale: { x: 1, y: 1 } });
    this.jackpotTextAnimation.time = 1000;
    this.jackpotTextAnimation.loop = false;
    this.jackpotTextAnimation.easing = PIXI.tween.Easing.outExpo();
    this.jackpotTextAnimation.stop();

    this.mask = new PIXI.Graphics();
    this.mask.beginFill(0xff0000);
    this.mask.drawRect(
      0,
      0,
      this.activeGameData.size[0],
      this.activeGameData.size[1]
    );
    this.mask.endFill();
    this.parent.addChild(this.mask);

    this.parent.mask = this.mask;

    // this.blackBG= new PIXI.Graphics();
    // this.blackBG.beginFill(0x000000);

    // if(this.activeGameData.isMobile)
    // {
    //     this.blackBG.drawRect(-1315/2,-780/2,1315,780);
    // }
    // else
    // {
    //     this.blackBG.drawRect(-1180/2,-350,1180,725);
    // }
    // this.blackBG.alpha=0.5
    // this.blackBG.endFill();
    this.blackBG = new PIXI.Sprite(PIXI.Texture.fromFrame("drop_black.png"));
    this.blackBG.anchor.set(0.5);
    this.blackBG.width = activeGameData.size[0] * 2;
    this.blackBG.height = activeGameData.size[1] * 2;
    this.blackBG.alpha = 0.5;
    // this.blackBG.interactive=false;
    // this.blackBG    .on('pointertap', function () {
    //     // e.preventDefault();
    //     return false;
    // }.bind(this));
    // this.blackBG.tint=0x000000;
    // this.blackBG.blendMode=PIXI.BLEND_MODES.ADD
    this.parent.addChild(this.blackBG);

    this.blackBG.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );
    this.exitTween = PIXI.tweenManager.createTween(this.parent);
    this.exitTween.from({ alpha: 1 }).to({ alpha: 0 });
    this.exitTween.time = 2000;
    // this.exitTween.delay=20;
    this.exitTween.loop = false;
    this.exitTween.easing = PIXI.tween.Easing.linear();
    this.exitTween.stop();

    this.exitTween.on(
      "end",
      function(parent: PIXI.Container, self: JackpotIntroText) {
        self.clear();
        parent;
      }.bind(this.exitTween, this.parent, this)
    );

    this.exitTween.on(
      "start",
      function(parent: PIXI.Container, self: JackpotIntroText) {
        // self.clear();
        parent;
        self.fadeIN();
      }.bind(this.exitTween, this.parent, this)
    );

    this.fireworksContainer = new PIXI.Container();
    this.parent.addChild(this.fireworksContainer);
    this.fireworks = [];

    let totalFireWorks = 12;
    let circleRadius = 100;

    for (let i = 0; i < totalFireWorks; i++) {
      let angle = ((360 / totalFireWorks) * i * Math.PI) / 180;
      if (i % 2 == 0) {
        this.fireworks[i] = createMovieClip("firework", 0, 13);
        angle = ((360 / totalFireWorks) * (i - 1) * Math.PI) / 180;
        this.fireworks[i].scale.set(3);
      } else {
        this.fireworks[i] = createMovieClip("lightStroke", 0, 13);
        this.fireworks[i].scale.set(1);
      }

      let x = circleRadius * Math.cos(angle);
      let y = circleRadius * Math.sin(angle);
      // console.log(i+1," angle = ",angle, " position = " ,x,y)

      this.fireworks[i].position.set(x, y);
      this.fireworks[i].anchor.set(0.1, 0.5);
      this.fireworks[i].rotation = angle;
      this.fireworks[i].loop = true;
      this.fireworks[i].stop();
      this.fireworks[i].animationSpeed = 0.3;
      this.fireworks[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      this.fireworksContainer.addChild(this.fireworks[i]);
    }
    this.fireworksContainer.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );

    this.parent.addChild(this.jackpotText);
    this.parent.alpha = 0;

    this.jackpotInSound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/12972918_jackpotIntro.m4a?" +
          "version=" +
          activeGameData.gameVersion,
      ],
      volume: 1,
      // loop:true,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        jackpotIn: [0, 5000, false],
      },
    });
    this.activeGameData.bonusMusicList.push(this.jackpotInSound);
  }

  // public setExitFunction(a:Function)
  // {
  //     this.exitFunction=a;
  //     console.log("function", a);
  //     this.exitFunction;

  // }

  public clear = (): void => {
    for (let i = 0; i < this.fireworks.length; i++) {
      this.fireworks[i].stop();
    }
    clearTimeout(this.exitTimer);
    this.parent.alpha = 0;
    this.jackpotTextAnimation.stop();
    this.exitTween.stop();
    // this.exitFunction();

    // jackppotGameFadeIn(this.activeGameData);
  };

  private fadeIN = (): void => {
    jackppotGameFadeIn(this.activeGameData);
  };

  public setInAnimations = (): void => {
    for (let i = 0; i < this.fireworks.length; i++) {
      this.fireworks[i].gotoAndPlay(0);
    }
    this.parent.alpha = 1;
    this.exitTween.reset();
    this.exitTimer = setTimeout(() => {
      this.exitTween.start();
    }, 3000);
    this.jackpotTextAnimation.reset();
    this.jackpotTextAnimation.start();
    this.jackpotInSound.play("jackpotIn");
  };

  public getBlackBG = (): PIXI.Sprite => {
    return this.blackBG;
  };
}
